import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import './Inventory.css';
import LeftSection from './LeftSection';
import SearchbarSection from './SearchbarSection';
import RightSection from './RightSection';

const Inventory = () => {
    const [cars, setCars] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(6);
    const navigate = useNavigate();

    useEffect(() => {
        fetch('https://skcapi.btcjapan.co/get-inventory.php')
            .then(response => response.json())
            .then(data => {
                setCars(data);
            })
            .catch(error => {
                console.error("Error fetching car details:", error);
            });
    }, []);

    const handleViewVehicle = (carId) => {
        navigate(`/vehicle-details/${carId}`);
    };

    // Calculate the current items to display
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = cars.slice(indexOfFirstItem, indexOfLastItem);

    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <>
            <div className="row">
                {/* Left Column */}
                <div className="col-lg-2 col-md-3 col-sm-12 leftcol">
                    <LeftSection />
                </div>

                {/* Middle Column */}
                <div className="col-lg-8 col-md-9 col-sm-12 middlecol">
                    <SearchbarSection />
                    <hr className="title-line"></hr>
                    {currentItems.map((car) => (
                        <div key={car.id} className="car-show">
                            <div className="row">
                                {/* Car Image */}
                                <div className="col-lg-4 col-md-12">
                                    <img
                                        src={`https://skcapi.btcjapan.co/${car.images}`}
                                        alt={car.model}
                                        onClick={() => handleViewVehicle(car.id)}
                                        style={{ cursor: 'pointer' }}
                                    />
                                </div>

                                {/* Car Details */}
                                <div className="col-lg-6 col-md-8 col-sm-12">
                                    <h3>{car.maker} {car.model} {car.year}</h3>                                    
                                    <h4>$ {car.price}</h4>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Engine</th>
                                                <td>{car.engine} CC</td>
                                            </tr>
                                            <tr>
                                                <th>Transmission</th>
                                                <td>{car.transmission}</td>
                                            </tr>
                                            <tr>
                                                <th>Color</th>
                                                <td>{car.color}</td>
                                            </tr>
                                            <tr>
                                                <th>Fuel</th>
                                                <td>{car.fuel}</td>
                                            </tr>
                                            <tr>
                                                <th>Mileage</th>
                                                <td>{car.mileage} KM</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>

                                {/* Buttons */}
                                <div className="col-lg-2 col-md-4 col-sm-12">
                                    <button>Get Price Quote</button>
                                    <button onClick={() => handleViewVehicle(car.id)}>View Vehicle</button>
                                </div>
                            </div>
                            <hr className="title-line"></hr>
                        </div>
                    ))}

                    {/* Pagination */}
                    <div className="pagination">
                        {Array.from({ length: Math.ceil(cars.length / itemsPerPage) }, (_, i) => (
                            <button
                                key={i + 1}
                                onClick={() => paginate(i + 1)}
                                className={currentPage === i + 1 ? 'active' : ''}
                            >
                                {i + 1}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Right Column */}
                <div className="col-lg-2 col-md-12 col-sm-12 rightcol">
                    <RightSection />
                </div>
            </div>
        </>
    );
};

export default Inventory;